// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogPlanningBathroomRemodelWinstonSalemRouteImport } from './routes/blog.planning-bathroom-remodel-winston-salem'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogPlanningBathroomRemodelWinstonSalemRoute = BlogPlanningBathroomRemodelWinstonSalemRouteImport.update({
            id: '/blog/planning-bathroom-remodel-winston-salem',path: '/blog/planning-bathroom-remodel-winston-salem',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogPlanningBathroomRemodelWinstonSalemRoute: BlogPlanningBathroomRemodelWinstonSalemRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)